import * as React from 'react';
import styled from 'styled-components';

import { colors } from '../colors/color';
import { inputBorderRadius } from './sharedContainerStyles';
import { DefaultInputStateCss, DisabledInputStateCss } from './sharedStyles';

export type SelectOption = {
    value: string,
    text: string,
    __innerHtml?:string
}

export type SelectOptionGroup = {
    text:string,
    options:SelectOption[]
}

export type SelectProps = {
    id?: string,
    selectedValue: string,
    options: (SelectOption | SelectOptionGroup)[],
    onChange: (newValue: string) => void,
    onFocus?: () => void,
    onBlur?: () => void,
    emptyText?: string,
    disabled?: boolean,
    width?:string,
    minWidth?:string
}
export function Select(props: SelectProps) {

    const handleChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
        props.onChange(event.target.value);
    };

    return (
        <StyledSelect
            id={props.id}
            name="select"
            value={props.selectedValue}
            onChange={handleChange}
            onFocus={props.onFocus}
            onBlur={props.onBlur}
            disabled={props.disabled}
            style={{minWidth:props.minWidth, width:props.width}}>
                <>
                    {props.emptyText !== undefined &&
                        <option value="">{props.emptyText}</option>
                    }

                    {props.options.map((option) =>{
                        if((option as SelectOptionGroup).options !== undefined){
                            const o = option as SelectOptionGroup;
                            return (
                                <optgroup key={o.text} label={o.text}>
                                    {o.options.map((option) => (
                                        <option key={option.value} value={option.value}>
                                            {option.text}
                                        </option>
                                    ))}
                                </optgroup>
                            );
                        }
                        else{
                            const o = option as SelectOption;
                            
                            return o.__innerHtml 
                                ?
                                    <option key={o.value} value={o.value} dangerouslySetInnerHTML={{__html:o.__innerHtml}} />
                                :
                                    <option key={o.value} value={o.value}>
                                        {o.text}
                                    </option>
                        }
                })}
                </>

        </StyledSelect>
    );
}

const StyledSelect = styled.select`
    ${DefaultInputStateCss.base.container}
    ${DefaultInputStateCss.base.text}
    border-radius: ${inputBorderRadius};
    box-sizing: border-box;
    font-family: inherit;
    font-size: 16px;
    line-height: 20px;
    padding: 10px 28px 10px 15px;
    width:100%;
    height: 42px;
    appearance: none;
    -webkit-appearance: none;
    -moz-appearance: none;
    background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='10' height='6' viewBox='0 0 10 6'%3E%3Cpath d='M1 1l4 4 4-4' fill='none' stroke='%233f3f3f' stroke-width='1.5' stroke-linecap='round'/%3E%3C/svg%3E");
    background-repeat: no-repeat;
    background-position: right 12px center;
    background-size: 10px 6px;

    & * {
        background-color:${colors.background.white};
    }
    
    &:hover {
        ${DefaultInputStateCss.hover}
    }
    &:focus-visible {
        ${DefaultInputStateCss.focus}
        outline: none;
    }
    &:active {
        ${DefaultInputStateCss.active}
    }
    &:disabled {
        ${DisabledInputStateCss.container}
        ${DisabledInputStateCss.text}
    }
`;